// extracted by mini-css-extract-plugin
module.exports = {"label":"InputWrapper_label__6J2tg","required":"InputWrapper_required__1UoCT","error":"InputWrapper_error__iu2oH"};